import { useContext } from "react";
import { ParkContext } from "common/providers/ParkProvider";

export const usePark = () => useContext(ParkContext);

export default usePark;
